import { Microgrid } from '../microgrid.types';
import { getMicrogridsMapper } from '../microgrid.utils';
import { useAxiosQuery } from 'hooks/useAxiosQuery';
import { getQueryKeys } from 'services/queryKeys';

export function useGetMicrogrids({ projectId, ...config }: { projectId?: number; enabled?: boolean }) {
  const path = `/projects/${projectId}/microgrids/`;
  const queryKeys = getQueryKeys(path);

  const { data, ...other } = useAxiosQuery<Microgrid[]>(queryKeys.list(), path, {
    method: 'GET',
    ...config,
  });

  const microgrids = getMicrogridsMapper(data) || [];

  return {
    microgrids,
    ...other,
  };
}
